import { Controller } from "@hotwired/stimulus";

const SECTION_SELECT_EVENT = "outline-rail:section-select";

// Dispatches the same `outline-rail:section-select` window event the left
// rail dispatches when its section title is clicked. The right rail's
// context-rail controller listens and swaps the settings frame to that
// section. Mounted on the canvas section card wrapper, which already
// carries data-section-id.
export default class extends Controller<HTMLElement> {
  select(event: Event) {
    const sectionId = this.element.dataset.sectionId;
    if (!sectionId) return;
    event.preventDefault();

    window.dispatchEvent(
      new CustomEvent(SECTION_SELECT_EVENT, {
        detail: { sectionId, source: this.element },
      }),
    );
  }
}
